import styled from 'styled-components';

export const ToggleButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.navText};
  cursor: pointer;
  padding: 10px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${({ theme }) => theme.navActiveBg};
    color: ${({ theme }) => theme.navTextActive};
  }
`;